import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import service from '@services/passenger-bus'

export const fetchGewogs = createAsyncThunk('gewogs/fetch', async (params, { rejectWithValue }) => {
  try { const res = await service.getGewogs(params); return { params, data: res.data, meta: res.meta } } catch (e) { return rejectWithValue(e.response?.data || e.message) }
})
export const fetchGewog = createAsyncThunk('gewogs/fetchOne', async (id, { rejectWithValue }) => { try { return await service.getGewog(id) } catch (e) { return rejectWithValue(e.response?.data || e.message) } })
export const addGewog = createAsyncThunk('gewogs/add', async (payload, { rejectWithValue }) => { try { return await service.addGewog(payload) } catch (e) { return rejectWithValue(e.response?.data || e.message) } })
export const saveGewog = createAsyncThunk('gewogs/save', async (payload, { rejectWithValue }) => { try { return await service.updateGewog(payload) } catch (e) { return rejectWithValue(e.response?.data || e.message) } })
export const removeGewog = createAsyncThunk('gewogs/remove', async (id, { rejectWithValue }) => { try { await service.deleteGewog(id); return id } catch (e) { return rejectWithValue(e.response?.data || e.message) } })

const slice = createSlice({
  name: 'gewogs',
  initialState: { data: [], meta: null, params: { page: 1, take: 10, order: 'ASC', q: '' }, selected: null, loading: false, error: null },
  reducers: { setGewogParams(s, a) { s.params = a.payload } },
  extraReducers: b => {
    b.addCase(fetchGewogs.pending, s => { s.loading = true })
     .addCase(fetchGewogs.fulfilled, (s, a) => { s.loading = false; s.data = a.payload.data; s.meta = a.payload.meta; s.params = a.payload.params })
     .addCase(fetchGewogs.rejected, (s, a) => { s.loading = false; s.error = a.payload })
     .addCase(fetchGewog.fulfilled, (s, a) => { s.selected = a.payload })
     .addCase(addGewog.fulfilled, (s, a) => { s.data.unshift(a.payload) })
     .addCase(saveGewog.fulfilled, (s, a) => { const i = s.data.findIndex(x => x.id === a.payload.id); if (i > -1) s.data[i] = a.payload })
     .addCase(removeGewog.fulfilled, (s, a) => { s.data = s.data.filter(x => x.id !== a.payload) })
  }
})

export const { setGewogParams } = slice.actions
export default slice.reducer
